const Config = {
    TOKEN: "token",
    CODE: "code",
    PERSONTYPECODE: "PERSONTYPECODE",
    NAME: "name",
    ORDERNUMBER: "orderNumber",
};
export default Config;
  